import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/sidebar";
import { Topbar } from "@/components/layout/topbar";
import { CommandPalette } from "@/components/command-palette";

export function AppLayout() {
  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[200] focus:rounded-lg focus:bg-primary focus:px-3 focus:py-1.5 focus:text-primary-foreground focus:text-sm focus:font-semibold">
        Skip to content
      </a>
      <div className="flex h-screen overflow-hidden bg-background">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden min-w-0">
          <Topbar />
          <main id="main-content" role="main" className="flex-1 overflow-y-auto">
            <div className="mx-auto w-full max-w-[1800px] p-4 lg:p-6 xl:p-8">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      <CommandPalette />
    </>
  );
}